import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'

import Spinner from '../../components/Spinner'

import * as actionCreators from '../../root/actions'
import style from './style'

import { LOGOUT_URL } from '../../api/endpoints'

export class Logout extends Component {
  componentDidMount () {
    const { apiRequest, logout } = this.props

    const request = {
      url: LOGOUT_URL,
      method: 'post'
    }

    const meta = {
      Component: 'Logout',
      onSuccess: logout
    }
    apiRequest(request, meta)
  }

  render () {
    const { api, classes } = this.props

    return (
      <div className={classes.base}>
        {api.get('isLoading') ? (
          <Spinner />
        ) : (
          <div className="loaderHolder">
            <h2>You are being logged out.</h2>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { containers, api } = state

  return {
    containers,
    api
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

const styleAndTheme = theme => style

export default injectSheet(styleAndTheme)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Logout)
)
